const CurrencyFormatter = ({
  value,
  currencyCode = true,
  del = false,
  numbercolor = "var(--color-heading)",
}) => {
  const formattedValue = Number(value || 0).toFixed(2);

  return (
    <span
      className="app-currency"
      style={{
        display: "inline-flex",
        alignItems: "center",
        columnGap: "2px",
        textDecoration: del ? "line-through" : "none",
        whiteSpace: "nowrap",
      }}
    >
      {currencyCode !== false && (
        <span
          className="icon-saudi_riyal app-currency__symbol"
          style={{
            color: "var(--color-primary)",
            fontSize: "25px",
            fontWeight: "normal",
            verticalAlign: "middle",
            lineHeight: "0.1",
          }}
        />
      )}

      <span
        className="app-currency__value"
        dir="ltr"
        style={{
          color: numbercolor,
          unicodeBidi: "isolate",
        }}
      >
        {formattedValue}
      </span>
    </span>
  );
};

export default CurrencyFormatter;
